export default __webpack_public_path__ + "static/expert-2-c5903c6aa7949c7db54389f397676908.jpg";